import * as React from 'react';
import Typography from '@mui/material/Typography';
import { newLineParser } from "../utils";
import { getExcerciseChoiceConfig } from "../utils";
import TranscriptionVideo from '../components/TranscriptionVideo';
import Slide from '@mui/material/Slide';
import { Choices } from '../enums';


export default function ExcerciseResponsePage({ pageId, excerciseId, choice, showfeedback, showOtherVideo, setNextPageButtonVisible }) {

    const [feedbackVisible, setFeedbackVisible] = React.useState(false);
    let choiceConfig = getExcerciseChoiceConfig(pageId, excerciseId, choice);
    let otherChoice = choice == Choices.A ? Choices.B : Choices.A
    let otherChoiceConfig = getExcerciseChoiceConfig(pageId, excerciseId, otherChoice);

    const showfeedbackOnEnded = () => {
        setFeedbackVisible(true);
    }

    const containerRef = React.useRef(null);

    let Feedback = ({ visible }) => (
        <Slide direction="down" in={visible} container={containerRef.current}>
            <div>
                <Typography variant="h6" gutterBottom>
                    Feedback:
                </Typography>
                <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
                    {newLineParser(choiceConfig['feedback'])}
                </Typography>
            </div>
        </Slide>
    );

    // Element used to scroll the page to the new shown video
    let ScrollTo = () => {
      const myComponentRef = React.useRef(null);

      // This code scrolls when the component comes into view
      React.useEffect(() => {
          const observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                // The component is now visible, scroll to it
                myComponentRef.current.scrollIntoView({ behavior: 'smooth' });
              }
            },
            { root: null, rootMargin: '400px', threshold: 0.5 } // Adjust threshold as needed
          );
      
          if (myComponentRef.current) {
            observer.observe(myComponentRef.current);
          }
      
          // Cleanup the observer when the component is unmounted
          return () => {
            if (myComponentRef.current) {
              observer.unobserve(myComponentRef.current);
            }
          };
        }, []);        

      return (
      <div ref={myComponentRef} >
      </div>)
  }


    return (
        <React.Fragment>
            <Typography variant="h5" gutterBottom>
                Keuze {choice}
            </Typography>

            <TranscriptionVideo src={choiceConfig['film']} transcription={choiceConfig['film_transcriptie']} onEnded={showfeedbackOnEnded} />

            <Feedback visible={feedbackVisible} />

            <div style={showOtherVideo ? {} : {display: 'none'}}>
              <hr />
              <Typography variant="h5" gutterBottom>
                  Keuze {otherChoice}
              </Typography>

              < ScrollTo />
              <TranscriptionVideo src={otherChoiceConfig['film']} transcription={otherChoiceConfig['film_transcriptie']} onEnded={() => setNextPageButtonVisible(true)}/>
            </div>   

        </React.Fragment>
    );
}
